import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from "@app/theme";
import { Platform, Dimensions,StyleSheet,ScrollView} from "react-native";
import {RadioButton,Circle} from '@app/sharedComponents/Icons/Icons';
import InputText from "@app/sharedComponents/TextInput/TextInput";
import { useEffect, useRef, useState } from "react";
import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader";
import { formatIndianCurrency } from "@app/utils/utility";
import Button from "@app/sharedComponents/Button/Button";
import ROUTE from "@app/navigationApp/routes";
import { useAppSelector } from "@app/store/hooks";
import { checkColor, REPAYMENT_COLLECTION_TYPE, trackEvent } from "@app/utils";
import { Info } from '@app/sharedComponents/Icons/Icons';
const screenWidth = Dimensions.get('window').width;

const FlexiPay = ({navigation,route}) => {
    const {paymentAmount,isLoanRenewal,paymentType} = route?.params || {};
    const [selectedAmount,setSelectedAmount] = useState('');
    const [payFull,setPayFull] = useState(null);
    const [manualAmountError,setManualAmountError] = useState('');
    const ref = useRef(null);
    const {principalOutStandingAmount, availableCreditAmount} = useAppSelector((state) => state.auth.creditDetails);
    useEffect(()=>{
        if(paymentAmount && !isLoanRenewal){
            setPayFull(false)
            setSelectedAmount(paymentAmount);
        }
    },[paymentAmount,isLoanRenewal])
    
    const fullselected = ()=>{
        trackEvent('REPAYMENT_AMOUNT_SELECTED_BUTTON', {repayment_type: 'fullPay'});
        setManualAmountError('')
        setPayFull(true)
        setSelectedAmount(isLoanRenewal?paymentAmount : principalOutStandingAmount);
    }

    const partialSelected = ()=>{
        trackEvent('REPAYMENT_AMOUNT_SELECTED_BUTTON', {repayment_type: 'partialPay'});
        setPayFull(false)
        setSelectedAmount('');
    }

    const onInput = (text: string) => {
        let formattedText = text.replace(/[^0-9.]/g, ''); // Allow only numbers and a single decimal point
        if (formattedText.startsWith('.')) {
            formattedText = '0' + formattedText; // Prepend 0 if input starts with a decimal point
        }
        if (formattedText.split('.').length > 2) {
            formattedText = formattedText.slice(0, formattedText.lastIndexOf('.')); // Remove extra decimal points
        }
        if (formattedText.includes('.')) {
            const [integerPart, decimalPart] = formattedText.split('.');
            formattedText = integerPart + '.' + decimalPart.slice(0, 2); // Limit to 2 decimal places
        }
        if (formattedText.length > 1 && formattedText[0] === '0' && formattedText[1] !== '.') {
            formattedText = formattedText.slice(1); // Remove leading zero unless it's a decimal
        }
        setSelectedAmount(formattedText);
        if (parseFloat(formattedText) > principalOutStandingAmount) {
            setManualAmountError('Maximum repayment amount is ₹' + formatIndianCurrency(principalOutStandingAmount));
        } else {
            setManualAmountError('');
        }
    }

    const continuePayment = () =>{
        // Need to handle collection type :- if shortfall then shortfall else principal repayment
        navigation.navigate(ROUTE.CONFIRM_PAYMENT_DETAILS,{selectedAmount,paymentType:paymentType??REPAYMENT_COLLECTION_TYPE.PRINCIPAL_REPAYMENT});
    }

    return (
        <>
        <PageHeaders  pageName={route?.name}  label="Flexi Pay" navigation={navigation} />
        <ThemedView style={{flex:1,backgroundColor:'#fff'}}>
            <ThemedView backgroundColor="bg-fill-secondary" px="lg" py="2xl">
                <ThemedText variant="b3r" color="text-secondary" mb="xs">
                    Outstanding amount
                </ThemedText>
                <ThemedText variant="b2s" color="text-primary">
                    ₹{formatIndianCurrency(Math.floor(isLoanRenewal?paymentAmount :principalOutStandingAmount))}
                </ThemedText>
                {isLoanRenewal &&
                <ThemedView flex={1} backgroundColor="bg-fill-warning" p="md" flexDirection="row"  borderRadius="sm" mt="lg">
                    <Info weight="fill" color={themeColorSet["icon-warning"]} size={20}/>
                    <ThemedView flex={1} ml="sm">
                        <ThemedText variant="b3r" color="text-primary" >This amount might not be accurate</ThemedText>
                        <ThemedText variant="b4r" color="text-primary" mb="sm" >Please contact support to get the latest outstanding dues.</ThemedText>
                        <Button label="Contact Support" type="OUTLINED" size="MD" handlePress={()=>navigation.navigate(ROUTE.CONTACT_US)}/>
                    </ThemedView>
                </ThemedView>}
            </ThemedView>
            <ThemedView p='lg' flex={1}  backgroundColor="bg-surface-primary">
                <ThemedText variant="h5s" color="text-primary" mb='2xl'>
                Select amount for repayment
                </ThemedText>
                <ThemedPressable flexDirection="row" alignItems="center" onPress={fullselected}  >
                    {
                        payFull===true?
                        <RadioButton size={24} weight="fill" color={checkColor("#1434CB")}/> :
                        <Circle size={24}  color="#C0D1E7"/>
                    }
                    <ThemedText variant={payFull===true? "b2s" : "b2r" } color="text-primary" ml='md'>
                    Pay full amount
                    </ThemedText>
                </ThemedPressable>
                <ThemedView flexDirection="row"  my="2xl" height={1}   backgroundColor="border-primary"/>
                <ThemedPressable flexDirection="row" onPress={partialSelected} >
                    {
                        payFull===false?
                        <RadioButton size={24} weight="fill" color={checkColor("#1434CB")}/> :
                        <Circle size={24}  color="#C0D1E7"/>
                    }
                    <ThemedView flex={1}>
                        <ThemedText variant={payFull===false? "b2s" : "b2r" } color="text-primary" ml='md' mb='lg'>
                        Pay partial amount
                        </ThemedText>
                    </ThemedView>
                </ThemedPressable>
                {payFull===false && 
                <ThemedView ml="4xl">
                    <InputText
                        ref={ref}
                        keyboardType="number-pad"
                        label="Enter amount"
                        placeHolder={'0'}
                        showLabel={true}
                        showAnimation
                        value={selectedAmount}
                        autoFocus={true}
                        onChangeText={onInput}
                        showErrorMessage={true}
                        hasError={manualAmountError}
                        showErrorMessageInFocus={true}
                    />
            </ThemedView>
                        }
            </ThemedView>
        </ThemedView>
        <ThemedView backgroundColor='bg-surface-primary' style={[Platform.OS === 'web' ? ls.webBtn:ls.nativeBtn ]}>
        <ThemedView height={1} width={screenWidth} backgroundColor='border-primary' />
        <ThemedView m="lg" justifyContent="center" alignItems="center" >
            {selectedAmount>0 && !manualAmountError &&<ThemedText variant="b3r" color='text-primary' mb="md">Paying ₹{formatIndianCurrency(selectedAmount)}</ThemedText>}
            <Button type="SOLID" size="MD" label="Select payment method" disabled={selectedAmount<=0 || manualAmountError} handlePress={continuePayment}/>
        </ThemedView>
        </ThemedView>
        </>

    );   
}
export default FlexiPay;
const ls = StyleSheet.create({
  nativeBtn:{
    position:'absolute',
    bottom:0,
  },
  webBtn:{
    position: screenWidth>450 ?'absolute':'fixed',
    bottom:0,
    left:0,
    width:'100%'
  }
});